<template>
  <div class="panel-body">
    <fieldset class="border">
      <legend v-if="description" class="border"><b>{{ description.title  }}</b></legend>
      <div class="text-left">
        <div v-if="description" v-html="replaceHTMLSellerInfo(description.content)"></div>
      </div>
    </fieldset>
  </div>
</template>

<script>

import DeliverySerivce from '@/services/deliveryservice'
import store from '@/store'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      description: {}
    }
  },
  created () {
    this.getDescriptions()
  },
  methods: {
    replaceHTMLSellerInfo,
    getDescriptions () {
      DeliverySerivce.getDescriptions()
        .then((response) => {
          this.description = response.data[0]
        })
        .catch((err) => {
          store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'top') {
      let logParams = {
        name: eventCode.delivery_requests.top_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/Top.vue